const cachedProcessEnv = { ...process.env };

export const getCachedProcessEnv = () => cachedProcessEnv;
